import React from 'react';
import tw from 'twin.macro';
import { getTitleColorFromTagColor } from 'components/colors';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { CJEvent } from 'types/event';
import { useFieldsToDisplay } from 'containers/CahierJournal/Toolbar/Filters/FieldsToDisplay/atom';
import { getDurationInHoursAndMinutesBetween } from '@teetsh/app/src/utils/time';
import { isCJEventActivitiesEmpty } from 'containers/CahierJournal/DayColumn/Seance/isCJEventActivitiesEmpty';
import { ClassroomsOrg } from 'types/school';

interface Props {
  event: CJEvent;
  classroomsOrg: ClassroomsOrg;
  collapsed: boolean;
  setCollpased?: (v: boolean) => void;
  classroomsToDisplayAsString?: string;
}

export function TitleLine(props: Props) {
  const { event, classroomsToDisplayAsString, setCollpased, collapsed } = props;
  const { title } = event;
  const areActivitiesEmpty = isCJEventActivitiesEmpty(event);
  const fieldsToDisplay = useFieldsToDisplay();

  return (
    <div
      data-testid="seance-title"
      tw="flex justify-between items-center flex-wrap"
    >
      <h3
        className="seance-title"
        css={[
          tw`font-bold text-base -mt-1`,
          getTitleColorFromTagColor(event.tag?.color),
          event?.tag?.color === 'white' && tw`text-neutral-intense`,
        ]}
      >
        {title}
        {!areActivitiesEmpty && title !== '' && setCollpased && (
          <span tw="relative z-0 inline-flex shadow-sm rounded-md -space-x-px print:hidden">
            <button
              type="button"
              onClick={e => {
                e.stopPropagation();
                setCollpased(!collapsed);
              }}
              className="group"
              tw="relative inline-flex items-center px-0 py-0 text-sm font-medium focus:z-10 focus:outline-none pb-1.5 ml-1"
            >
              <ChevronDownIcon tw="h-4 w-4 invisible" aria-hidden="true" />
              <ChevronDownIcon
                css={[
                  tw`transition duration-200 ease-in-out absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 h-4 w-4 hover:scale-150`,
                  !collapsed && tw`rotate-180`,
                ]}
                aria-hidden="true"
              />
            </button>
          </span>
        )}
      </h3>
      {fieldsToDisplay?.includes('duration') && (
        <small tw="text-right">
          {getDurationInHoursAndMinutesBetween(event.start, event.end)}{' '}
          {classroomsToDisplayAsString || null}
        </small>
      )}
    </div>
  );
}
